import { OPEN_ACCORDION_SECTION, CLOSE_ACCORDION_SECTION, EXPAND_ACCORDION, CLOSE_ACCORDION } from '../lib/types';

const initialState = {
  accordionStates: {
    tutorialProjectInformation: true,
    tutorialBackgroundAndTools: false,
    tutorialSystemParameters: false,
    tutorialDrawingsAndReports: false,
    tutorialContactUs: false,
  },
  lastOppenedSection: 'tutorialProjectInformation',
  expandAccordion: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_ACCORDION_SECTION:
      return {
        ...state,
        accordionStates: {
          ...state.accordionStates,
          [action.payload]: true,
        },
        lastOppenedSection: action.payload,
      };
    case CLOSE_ACCORDION_SECTION:
      return {
        ...state,
        accordionStates: {
          ...state.accordionStates,
          [action.payload]: false,
        },
      };
    case EXPAND_ACCORDION:
      return {
        ...state,
        expandAccordion: action.payload,
      };
    case CLOSE_ACCORDION:
      return {
        ...state,
        accordionStates: {
          tutorialProjectInformation: false,
          tutorialBackgroundAndTools: false,
          tutorialSystemParameters: false,
          tutorialComponents: false,
          tutorialContactUs: false,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/accordion-reducer.js